export default {
  "build": 59,
  "version": "0.8",
  "date": "8/26/2024, 8:00:49 PM",
  "time": 1724727649367
};